<template>
	<div>
		<h1 class="my-5" v-html="title" />

		<b-form class="mb-5">
			<b-form-row class="mb-4">
				<b-col cols="12" md="6" class="mb-4 mb-md-0">
					<label for="company-name" class="h4"><b>Nom</b> de l'entreprise</label>

					<b-form-group invalid-feedback="Le nom de l'entreprise est obligatoire">
						<b-input
						id="company-name"
						v-model.trim="$v.company.name.$model"
						:state="validateState($v.company.name)" />
					</b-form-group>
				</b-col>

				<b-col cols="12" md="6">
					<label for="company-activity" class="h4"><b>Activité</b> de l'entreprise</label>

					<b-form-group invalid-feedback="L'activité de l'entreprise est obligatoire">
						<b-input
						id="company-activity"
						v-model.trim="$v.company.activity.$model"
						:state="validateState($v.company.activity)" />
					</b-form-group>
				</b-col>
			</b-form-row>

			<b-form-row class="mb-5">
				<b-col>
					<label class="h4 d-block"><b>Forme juridique</b> de l'entreprise</label>

					<b-form-radio-group
					v-model="company.legalForm"
					:options="legalForms"
					stacked
					buttons
					button-variant="outline-primary"
					size="lg"
					@change="legalFormChange($event)" />
				</b-col>
			</b-form-row>

			<b-form-row class="mb-5">
				<b-col cols="12" md="6">
					<label class="h4"><b>Adresse</b> de domiciliation</label>

					<b-form-select
					v-model="domiciliation.address.name"
					:options="this.getDomiciliationAddresses" />
				</b-col>
			</b-form-row>

			<b-form-row class="mb-5">
				<b-col cols="12" lg="6" class="mb-5 mb-md-0">
					<label class="h4">Domiciliation <b>pour un</b></label>
					<br />

					<b-form-radio-group
					v-model="domiciliation.status"
					:options="statutes"
					buttons
					button-variant="outline-primary"
					size="lg" />
				</b-col>

				<b-col cols="12" lg="6">
					<label class="h4"><b>Type</b> de domiciliation</label>
					<br />

					<b-form-radio-group
					v-model="domiciliation.type"
					:options="types"
					buttons
					button-variant="outline-primary"
					size="lg" />

					<b-form-group label="Souhaitez-vous qu'Assistel s'occupe de la création de votre entreprise ?" class="mt-3" v-if="domiciliation.type === 'Création'">
						<b-form-radio @change="redirectToCreation()" v-model="domiciliation.creationByAssistel" value="Oui">Oui</b-form-radio>
						<b-form-radio v-model="domiciliation.creationByAssistel" value="Non">Non</b-form-radio>
					</b-form-group>
				</b-col>
			</b-form-row>

			<b-form-group v-if="domiciliation.type === 'Transfert'">
				<label class="h4 mb-4" v-if="domiciliation.status === 'Siège social'"><b>Siège</b> social</label>
				<label class="h4 mb-4" v-else><b>Etablissement</b> secondaire</label>

				<b-form-row>
					<b-col cols="12" md="6">
						<b-form-group label="Adresse" label-for="company-address">
							<b-input
							id="company-address"
							v-model.trim="$v.company.address.place.$model"
							aria-describedby="company-address-live-feedback"
							:state="validateState($v.company.address.place)" />

							<b-form-invalid-feedback id="company-address-live-feedback">L'adresse de l'entreprise est obligatoire</b-form-invalid-feedback>
						</b-form-group>
					</b-col>

					<b-col cols="12" md="2">
						<b-form-group label="Code postal" label-for="company-zip">
							<b-input
							id="company-zip"
							v-model.trim="$v.company.address.zipCode.$model"
							aria-describedby="company-zip-live-feedback"
							@change="getCitiesByZipCode"
							:state="validateState($v.company.address.zipCode)" />

							<b-form-invalid-feedback id="company-address-live-feedback">Le code postal est obligatoire, doit être au format numérique et comporter 5 chiffres.</b-form-invalid-feedback>
						</b-form-group>
					</b-col>

					<b-col cols="12" md="4">
						<b-form-group label="Ville" label-for="company-city">
							<b-input
							id="company-city"
							v-model.trim="$v.company.address.city.$model"
							list="citiesList"
							aria-describedby="company-city-live-feedback"
							:state="validateState($v.company.address.city)" />

							<b-datalist id="citiesList" :options="citiesList" />

							<b-form-invalid-feedback id="company-address-live-feedback">La ville de l'entreprise est obligatoire</b-form-invalid-feedback>
						</b-form-group>
					</b-col>
				</b-form-row>
			</b-form-group>
		</b-form>

		<OtherLegalFormModal :modalShow="modalShow" :type="'domiciliation'" />
	</div>
</template>

<script>
    import { mapState } from 'vuex';
    import { mapGetters } from 'vuex'

    import axios from 'axios';

		import OtherLegalFormModal from '../../components/OtherLegalFormModal.vue';

    import { required, numeric, minLength, maxLength } from "vuelidate/lib/validators";

    export default {
			components: {
				OtherLegalFormModal
			},
			props: ['clickedNext'],
			data() {
				return {
					title         : "<strong>Domiciliez</strong> votre entreprise",
					modalShow: false,
					statutes      : [
						{ text: 'Siège social', value: 'Siège social' },
						{ text: 'Etablissement secondaire', value: 'Etablissement secondaire' }
					],
					types         : [
						{ text: 'Création', value: 'Création' },
						{ text: 'Transfert', value: 'Transfert' }
					],
					citiesList    : [],
					company       : {
						name      : null,
						activity  : null,
						address : {
							place   : null,
							zipCode : null,
							city    : null
						},
						legalForm : 'EURL / SARL',
					},
					domiciliation : {
						address: {
								name: null,
								place: null,
								zipCode: null,
								city: null
						},
						status  : 'Siège social',
						type    : 'Création',
						creationByAssistel: 'Non'
					}
				}
			},
			validations() {
				let datas = {
					company       : {
						name      : { required },
						activity  : { required },
						legalForm : { required }
					},
					domiciliation : {
						address : { required },
						status  : { required },
						type    : { required }
					}
				};

				if (this.domiciliation.type === 'Transfert') {
					datas.company.address = {
						place   : { required },
						zipCode : {
							required,
							numeric,
							minLength: minLength(5),
							maxLength: maxLength(5)
						},
						city    : { required }
					};
				}

				return datas;
			},
			watch: {
				$v: {
					handler (val) {
						this.$store.commit('updateDomiciliationCompany', { company: this.company, domiciliation: this.domiciliation });

						let salesAgentQuality = (this.company.legalForm !== "SAS" && this.company.legalForm !== "SASU") ? "Dirigeant" : "Président";
						this.$store.commit('updateDomiciliationSalesAgentQuality', { salesAgentQuality : salesAgentQuality })

						if (!val.$invalid) {
							this.$emit('can-continue', { value: true });
						} else {
							this.$emit('can-continue', { value: false });
						}
					},
					deep: true
				},
				clickedNext () {
					this.$v.$touch();
				}
			},
			methods: {
				redirectToCreation () {
					this.$router.push('/creation/commande');
				},
				getCitiesByZipCode (zipCode) {
					if (zipCode.length === 5) {
						let requestTarget = this.apiDomain + '/get-cities-by-zip-code';

						axios.post(requestTarget, {
							zipCode : zipCode
						})
						.then((response) => {
							let citiesByZipCode = response.data.citiesByZipCode;
							let cities = [];

							citiesByZipCode.forEach((city) => {
								cities.push(city.nomCommune)
							});

							this.citiesList = cities;
						});
					}
				},
				validateState (v) {
					if (!v.$dirty) {
						return null;
					} else {
						return (v.$error) ? false : true
					}
				},
				legalFormChange (event) {
					this.modalShow = (event === 'Autre' || event === 'Auto-Entrepreneur / Micro-Entreprise') ? true : false;
				},
			},
			computed: {
				...mapState(['apiDomain', 'legalForms']),
				...mapGetters(['getDomiciliationAddresses'])
			},
			mounted() {
				let index = this.$route.params.addressId - 1;

				this.getDomiciliationAddresses.forEach((address, i) => {
					if (i === index) {
						this.domiciliation.address.name = address.text;
					}
				});
			}
    }
</script>
